import React from "react";

const WhatsAppButton = () => {
  const handleClick = () => {
    const phoneNumber = "201100781013"; // Replace with your WhatsApp number in international format
    const message = "Hello, I need help!"; // Optional pre-filled message
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <button
      style={{
        backgroundColor: "#25d366", // WhatsApp green
        color: "white",
        padding: "14px 30px",
        border: "none",
        borderRadius: "50px", // Rounded corners
        fontSize: "18px",
        fontWeight: "bold",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "15px", // Space between icon and text
        transition: "all 0.3s ease-in-out", // Smooth transition
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Light shadow for a modern look
        marginTop: "20px", // Space above the button
      }}
      onClick={handleClick}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#128c7e")} // Dark green on hover
      onMouseOut={(e) => (e.target.style.backgroundColor = "#25d366")} // Revert to WhatsApp green
    >
      <i
        className="fa fa-whatsapp"
        style={{
          fontSize: "24px", // Slightly larger icon size
          marginRight: "10px", // Space between icon and text
        }}
      ></i>
      <span>Chat with us on WhatsApp</span>
    </button>
  );
};

export default WhatsAppButton;
